<template>
    <div class="collapsible" id="infos-intervention" :class="stateClass">

        <div class="collapsible-head wrap" id="head-intervention"
             @click="$emit('openCollapsible','infos-intervention')">
            INFORMATIONS SUR L' INTERVENTION
            <i class="icon-go"></i>
        </div>

        <div class="collapsible-body wrap" id="info-intervention">

            <div class="colform">
                <label>Déplacement</label>
                <div class="skin-select">
                    <select class="dossier" name="temps_deplacement" v-model="informations.temps_deplacement" @change="updateInfos">
                        <option :value="null">Sélectionnez une valeur</option>
                        <option>Forfait</option>
                        <option>Forfait zone 1</option>
                        <option>Forfait zone 2</option>
                        <option>Forfait zone 3</option>
                        <option>Forfait hors zone</option>
                        <option>Forfait nuit</option>
                        <option>15min</option>
                        <option>30min</option>
                        <option>45min</option>
                        <option>1h00min</option>
                        <option>1h15min</option>
                        <option>1h30min</option>
                        <option>1h45min</option>
                        <option>2h00min</option>
                        <option>2h30min</option>
                        <option>3h00min</option>
                    </select>
                </div>
            </div>
            <div class="colform">
                <label>Kilométrage (Km)</label>
                <input title="miles" type="number" min="0" step="1" v-model.number="informations.kilometrage" @change="updateInfos">
            </div>
            <div class="clear"></div>

            <label>Temps d'intervention</label>
            <div class="skin-select">
                <select class="dossier" name="temps_intervention" v-model="informations.temps_intervention" @change="updateInfos('temps_intervention')">
                    <option :value="null">Sélectionnez une valeur</option>
                    <option v-for="temps in optionsTempsIntervention" :key="temps">{{ temps }}</option>
                </select>
            </div>

            <div class="colform">
                <label>Heure d'arrivée</label>
                <input title="heureDarrive" type="time" pattern="[0-9]{2}:[0-9]{2}" v-model="informations.heure_arrivee"
                       @change="setHeureArrivee($event)">
            </div>
            <div class="colform">
                <label>Heure de départ</label>
                <input title="heureDepart" type="time" pattern="[0-9]{2}:[0-9]{2}" v-model="informations.heure_depart"
                       @change="setHeureDepart($event)">
            </div>
            <div class="clear"></div>

            <div class="colform">
                <label>Nombre de techniciens</label>
                <input title="numberOfTechs" type="number" min="0" v-model.number="informations.techs" @change="updateInfos">
            </div>
            <div class="colform">
                <label>Noms des techniciens</label>
                <input title="techNames" type="text" v-model="informations.namesTechniciens" @change="updateInfos"
                       @input="persisterInfosDiffere">
            </div>
            <div class="clear"></div>

            <label>Type d'intervention</label>
            <div class="checkfull">
                <input type="checkbox" id="preventif" name="preventif" v-model="informations.preventif"
                       @change="typeUniqueCheck('preventif')">
                <label class="btn check" for="preventif">
                    PREVENTIF (visite d'entretien)
                    <i class="icon-valid"></i>
                </label>
            </div>
            <div class="checkfull">
                <input type="checkbox" id="correctif" name="correctif" v-model="informations.correctif"
                       @change="typeUniqueCheck('correctif')">
                <label class="btn check" for="correctif">
                    CORRECTIF (dépannage)
                    <i class="icon-valid"></i>
                </label>
            </div>
            <div class="checkfull">
                <input type="checkbox" id="from-devis" name="from-devis" v-model="informations.fromDevis"
                       @change="updateInfos">
                <label class="btn check" for="from-devis">
                    Selon devis
                    <i class="icon-valid"></i>
                </label>
            </div>
            <div class="checkfull">
                <input type="checkbox" id="garantie" name="garantie" v-model="informations.garantie"
                       @change="updateInfos">
                <label class="btn check" for="garantie">
                    Installation sous garantie
                    <i class="icon-valid"></i>
                </label>
            </div>
            <div class="checkfull">
                <input type="checkbox" id="finish" name="finish" v-model="informations.finish" @change="updateInfos">
                <label class="btn check" for="finish">
                    Travaux terminés
                    <i class="icon-valid"></i>
                </label>
            </div>
            <div class="checkfull">
                <input type="checkbox" id="need-devis" name="need-devis" v-model="informations.needDevis"
                       @change="updateInfos">
                <label class="btn check" for="need-devis">
                    Devis à réaliser
                    <i class="icon-valid"></i>
                </label>
            </div>

            <label>Travaux effectués</label>
            <textarea class="dossier" placeholder="Décrivez les travaux effectués ici" name="travaux_effectues"
                      v-model="informations.travauxEffectues" @change="updateInfos"
                      @input="persisterInfosDiffere"></textarea>

            <label>Observations</label>
            <textarea class="dossier" placeholder="Saisissez vos observations sur l'intervention ici"
                      name="observ_intervention" v-model="informations.observations" @change="updateInfos"
                      @input="persisterInfosDiffere">
            </textarea>

            <div class="img-intervention">
                <input type="file" accept="image/*" ref="inputPhoto" name="intervention-photo" id="intervention-photo"
                       style="display: none;" @change="newPhoto">

                <ul id="preview-photo-intervention">
                    <li v-for="photo in photos" :key="photo.id">
                        <a href="javascript: void 0" class="del-photo btn" @click.prevent="deletePhoto(photo)"><i
                                class="icon-delete"></i></a>
                        <div class="photo-container">
                            <img v-if="!photo.loadError"
                                 alt="photo intervention"
                                 :src="photo.data64"
                                 @error="onPhotoError(photo)">
                            <div v-else class="photo-placeholder">
                                <i class="icon-photo"></i>
                                <span>Photo déjà envoyée</span>
                                <small>Non chargée car pas de réseau</small>
                            </div>
                            <small v-if="photo.isUrl" class="photo-synced-label">Photo déjà synchronisée</small>
                        </div>
                        <div class="photo-commentaire">
                            <template v-if="estEnAttente(photo)">
                                <textarea
                                        v-model="photo.commentaire"
                                        maxlength="255"
                                        rows="2"
                                        placeholder="Commentaire (facultatif)"
                                        @input="saveCommentaireDiffere(photo)"
                                        @blur="saveCommentaire(photo)"></textarea>
                                <small>{{ (photo.commentaire || '').length }}/255</small>
                            </template>
                            <p v-else-if="photo.commentaire">{{ photo.commentaire }}</p>
                        </div>
                    </li>
                </ul>
            </div>

            <a class="photo btn" href="javascript: void 0" @click.prevent="tryAddPhoto">
                Ajouter une photo
                <i class="icon-photo"></i>
            </a>

        </div>

    </div>
</template>

<script>

    import moment from 'moment'
    import loadImage from 'blueimp-load-image'
    import PhotoFiche from '../../../../js/models/PhotoFiche'

    const TEMPS_INTERVENTION = [
        '15min', '30min', '45min', '1h00min', '1h15min', '1h30min', '1h45min', '2h00min', '2h30min', '3h00min',
        '3h30min', '4h00min', '4h30min', '5h00min', '5h30min', '6h00min', '6h30min', '7h00min', '7h30min',
        '8h00min', '8h30min', '9h00min', '9h30min', '10h00min',
        '1 jour', '2 jours', '3 jours', '4 jours', '5 jours', 'Autre', 'Forfait'
    ];

    export default {

        data() {
            return {
                now: moment().format('HH:mm'),
                photos: [],
                previousTempsIntervention: null
            }
        },

        props: {
            open: null,
            informations: {
                temps_deplacement: null,
                temps_intervention: null,
                heure_arrivee: null,
                heure_depart: null,
                kilometrage: null,
                pieces: null,
                observations: null,
                photo64: null
            },
        },

        created() {
            // listPhotos contient les images en base64 : pas de réécriture à chaque frappe.
            this.saveCommentaireDiffere = _.debounce(photo => this.saveCommentaire(photo), 600);

            // Android peut tuer l'onglet pendant que l'appareil photo est au premier plan :
            // attendre le blur ferait perdre la saisie en cours (MD-929).
            this.persisterInfosDiffere = _.debounce(() => this.updateInfos(), 800);
            this.onVisibilityChange = () => {
                if (document.visibilityState === 'hidden') {
                    this.persisterInfosDiffere.flush();
                    this.saveCommentaireDiffere.flush();
                }
            };
            document.addEventListener('visibilitychange', this.onVisibilityChange);
        },

        beforeDestroy() {
            this.saveCommentaireDiffere.flush();
            this.persisterInfosDiffere.flush();
            document.removeEventListener('visibilitychange', this.onVisibilityChange);
        },

        methods: {
            setHeureArrivee(event) {
                this.informations.heure_arrivee = event.target.value;
                this.updateInfos()
            },
            setHeureDepart(event) {
                this.informations.heure_depart = event.target.value;
                this.updateInfos()
            },

            updateInfos(change = null) {
                if (this.informations.temps_intervention === "Autre" && change === 'temps_intervention') {
                    this.askTempsInterventionAutre();
                    return;
                }
                this.persisterInfosDiffere.cancel();
                this.$emit('infosChanged', this.informations);
                this.$emit('photosChanged', this.photos);
            },

            restoreTempsIntervention() {
                this.informations.temps_intervention = this.previousTempsIntervention;
                this.$emit('infosChanged', this.informations);
            },

            askTempsInterventionAutre() {
                swal({
                    "title": "Temps d'intervention",
                    html:
                        '<input type="number" id="swal-input1" class="swal2-input removeNumeric" style="width: 60px" min="0" max="150" inputmode="numeric">&nbsp; h ' +
                        '<input type="number" id="swal-input2" class="swal2-input removeNumeric" style="width: 60px" min="0" max="59" inputmode="numeric">&nbsp; min',
                    focusConfirm: false,
                }).then(() => {
                    const hours = parseInt(document.getElementById('swal-input1').value) || 0;
                    let minutes = parseInt(document.getElementById('swal-input2').value) || 0;
                    if((hours === 0 && minutes === 0) || hours < 0 || minutes < 0 || hours > 150 || minutes > 59) {
                        swal('Veuillez saisir un temps valide', '', 'warning');
                        this.restoreTempsIntervention();
                        return;
                    }

                    if (minutes >= 1 && minutes <= 9) {
                        minutes = '0' + minutes; // Ajoute un zéro devant les chiffres de 1 à 9
                    }

                    this.informations.temps_intervention = hours + 'h' + minutes + 'min';
                    this.$emit('infosChanged', this.informations);
                }, () => {
                    this.restoreTempsIntervention();
                })
            },

            typeUniqueCheck(type) {
                if (type === 'preventif' && this.informations.preventif === true && this.informations.correctif === true) {
                    this.informations.correctif = false
                } else if (type === 'correctif' && this.informations.preventif === true && this.informations.correctif === true) {
                    this.informations.preventif = false
                }
                this.updateInfos()
            },

            tryAddPhoto() {
                if (this.photos.length === 9) {
                    swal('9 Photos maximum', '', 'warning')
                } else {
                    this.persisterInfosDiffere.flush();
                    this.saveCommentaireDiffere.flush();
                    // Sans ça, rechoisir la même photo ne déclenche pas « change ».
                    this.$refs['inputPhoto'].value = '';
                    this.$refs['inputPhoto'].click()
                }
            },

            newPhoto(e) {

                let vueInstance = this;
                let idFi = this.$route.params.id;
                let id = 'P-' + +new Date();
                let fichier = e.target.files[0];

                if (!fichier) {
                    return;
                }

                const messageIndisponible = 'Cette photo n\'est pas disponible hors connexion (par exemple stockée sur iCloud). ' +
                    'Téléchargez-la sur le téléphone avec du réseau, ou prenez-la avec l\'appareil photo.';

                // iOS renvoie un fichier vide quand l'original n'est que sur iCloud et qu'il n'y a pas de réseau.
                if (fichier.size === 0) {
                    swal('Photo indisponible', messageIndisponible, 'warning');
                    return;
                }

                const ajouterPhoto = function (img) {
                    const ctx = img.getContext('2d');
                    ctx.globalCompositeOperation = 'destination-over';
                    ctx.fillStyle = '#ffffff';
                    ctx.fillRect(0, 0, img.width, img.height);
                    ctx.globalCompositeOperation = 'source-over';

                    let photo = {
                        data64: img.toDataURL('image/jpeg', 0.7),
                        commentaire: null,
                        idFi,
                        id
                    };

                    vueInstance.photos.push(photo);
                    vueInstance.updateInfos();
                    PhotoFiche.addOffline(photo)
                };

                const echec = function () {
                    const detail = (fichier.type || 'type inconnu') + ', ' + Math.round(fichier.size / 1024) + ' Ko';
                    swal('Erreur', 'Impossible de charger cette image, vérifiez le format du fichier. (' + detail + ')', 'error');
                };

                // Repli : décodeur natif du navigateur, plus tolérant que le chargement via <img>.
                const repli = function () {
                    if (typeof createImageBitmap !== 'function') {
                        echec();
                        return;
                    }
                    const decoder = createImageBitmap(fichier, {imageOrientation: 'from-image'})
                        .catch(function () {
                            return createImageBitmap(fichier);
                        });

                    decoder.then(function (bitmap) {
                        let canvas;
                        try {
                            const ratio = Math.min(1, 1280 / Math.max(bitmap.width, bitmap.height));
                            canvas = document.createElement('canvas');
                            canvas.width = Math.round(bitmap.width * ratio);
                            canvas.height = Math.round(bitmap.height * ratio);
                            canvas.getContext('2d').drawImage(bitmap, 0, 0, canvas.width, canvas.height);
                        } finally {
                            if (bitmap.close) {
                                bitmap.close();
                            }
                        }
                        return canvas;
                    }).then(ajouterPhoto, echec);
                };

                loadImage(
                    fichier,
                    function (img) {
                        if (img instanceof Event) {
                            repli();
                            return;
                        }
                        ajouterPhoto(img);
                    },
                    {
                        maxWidth: 1280,
                        maxHeight: 1280,
                        orientation: true,
                        canvas: true
                    }
                );
            },

            async deletePhoto(photo) {
                try {
                    await swal({
                        title: 'Supprimer la photo ?',
                        text: 'Cette action est irréversible.',
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Supprimer',
                        cancelButtonText: 'Annuler',
                        confirmButtonColor: '#d33',
                    });
                } catch (e) {
                    return;
                }

                if (photo.isUrl) {
                    try {
                        await PhotoFiche.removeOnline(photo.id);
                    } catch (e) {
                        swal('Erreur', 'Impossible de supprimer la photo, vérifiez votre connexion.', 'error');
                        return;
                    }
                    this.photos = _.filter(this.photos, p => p.id !== photo.id);
                } else {
                    this.photos = _.filter(this.photos, p => p.id !== photo.id);
                    PhotoFiche.remove(photo.id);
                }
            },

            // Le commentaire ne se modifie que tant que la photo attend la synchro (MD-688) :
            // l'action « add » encore en file enverra la dernière valeur.
            // Une photo envoyée pendant la session garde isUrl à faux mais reçoit l'id serveur.
            estEnAttente(photo) {
                return !photo.isUrl && String(photo.id).startsWith('P-');
            },

            saveCommentaire(photo) {
                if (!this.estEnAttente(photo)) {
                    return;
                }

                PhotoFiche.updateCommentaire(photo.id, photo.commentaire);
            },

            onPhotoError(photo) {
                this.$set(photo, 'loadError', true);
            },

            async fetchPhotos() {
                let idFi = this.$route.params.id;
                let photos = await PhotoFiche.getListForFiche(idFi);
                this.photos = photos.map(function(p) { p.loadError = false; return p; })
            }

        }
        ,

        mounted() {
            if (!this.informations.hasOwnProperty('heure_depart')) {
                this.informations.heure_depart = this.now
            }

            this.fetchPhotos()
        },

        watch: {
            'informations.temps_intervention': {
                immediate: true,
                handler(val) {
                    if (val !== 'Autre') {
                        this.previousTempsIntervention = val;
                    }
                }
            }
        },

        computed: {
            optionsTempsIntervention() {
                const options = TEMPS_INTERVENTION.slice();
                const current = this.informations.temps_intervention;
                if (current && options.indexOf(current) === -1) {
                    options.push(current);
                }
                return options;
            },

            stateClass() {
                if (this.open === 'infos-intervention') {
                    return 'open'
                } else {
                    return ''
                }
            }
        }

    }

</script>

<style>

    #info-intervention a.photo {
        position: relative;
        display: block;
        height: 50px;
        width: 220px;
        color: #fff;
        text-transform: uppercase;
        background-color: #5698d2;
        border-radius: 5px;
        text-align: left;
        line-height: 3.5;
        padding-left: 20px;
        margin-bottom: 20px;
    }

    #info-intervention a.photo i {
        position: absolute;
        right: 20px;
        top: 10px;
        color: #fff;
        font-size: 2.3rem;
    }

    div.colform {
        display: block;
        float: left;
        width: 50%;
        padding-right: 10px;
    }

    #info-intervention div.checkfull label.btn.check {
        position: relative;
        background-color: #e2e2e2;
        color: #999;
        padding-left: 20px;
        font-size: 1.5rem;
        font-weight: 400;
        text-transform: none;
        margin-bottom: 15px;
        margin-top: 15px;
    }

    #info-intervention div.checkfull label.btn.check i {
        position: absolute;
        top: 10px;
        font-size: 2.3rem;
        right: 15px;
        color: #999;
    }

    #info-intervention div.checkfull input[type="checkbox"] {
        display: none;
    }

    #info-intervention input:checked + label.btn.check {
        background-color: #86bc24;
        color: #fff;
    }

    #info-intervention input:checked + label.btn.check i {
        color: #fff;
    }

    #preview-photo-intervention li {
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 15px 0;
        border-bottom: 1px solid #ccc;
        position: relative;
    }

    #preview-photo-intervention li:last-child {
        margin-bottom: 20px;
        border-bottom: none;
    }

    div.photo-container {
        position: relative;
    }

    #preview-photo-intervention .photo-commentaire {
        width: 100%;
        margin-top: 10px;
    }

    #preview-photo-intervention .photo-commentaire textarea {
        width: 100%;
        box-sizing: border-box;
        resize: vertical;
    }

    #preview-photo-intervention .photo-commentaire small {
        display: block;
        text-align: right;
        color: #888;
    }

    #preview-photo-intervention .photo-commentaire p {
        margin: 0;
        font-style: italic;
        word-wrap: break-word;
    }

    div.photo-container img {
        max-width: 100%;
        max-height: 600px;
        object-fit: contain;
    }

    a.del-photo {
        display: block;
        position: absolute;
        right: 10px;
        top: 10px;
        width: 50px;
        height: 40px;
        background-color: #c31616;
        border-radius: 5px;
        color: #fff;
        text-align: center;
        line-height: 31px;
        font-size: 2.7rem;
        z-index: 10;
    }

    a.del-photo i {
        left: 0;
        right: 0;
        line-height: 35px;
    }

    .photo-placeholder {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 150px;
        background-color: #f0f0f0;
        border: 2px dashed #ccc;
        border-radius: 5px;
        color: #999;
    }

    .photo-placeholder i {
        font-size: 3rem;
        margin-bottom: 10px;
    }

    .photo-placeholder span {
        font-size: 1.4rem;
    }

    .photo-placeholder small {
        font-size: 1.1rem;
        color: #bbb;
        margin-top: 3px;
    }

    .photo-synced-label {
        display: block;
        text-align: center;
        color: #999;
        font-size: 1.2rem;
        margin-top: 5px;
    }

    .removeNumeric::-webkit-inner-spin-button,
    .removeNumeric::-webkit-outer-spin-button,
    .removeNumeric {
        -webkit-appearance: none;
        margin: 0;
        -moz-appearance: textfield;
    }


</style>



// WEBPACK FOOTER //
// Infos.vue?d216cfd8